import { useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useDailyFeedbackPrompt } from "@/hooks/useDailyFeedbackPrompt";
import { useLocation } from "react-router-dom";
import UserReviewModal from "@/components/UserReviewModal";

const DailyFeedbackPopup = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { showPopup, markDismissed, markDisabledForever, markSubmitted } = useDailyFeedbackPrompt();
  const popupVisibleRef = useRef(false);

  if (!showPopup || !user) {
    popupVisibleRef.current = false;
    return null;
  }

  if (!popupVisibleRef.current) {
    popupVisibleRef.current = true;
  }

  return (
    <UserReviewModal
      open
      source="popup"
      showNeverAgain
      onClose={() => {
        markDismissed();
      }}
      onSubmitted={() => {
        markSubmitted();
      }}
      onNeverAgain={() => {
        markDisabledForever();
      }}
    />
  );
};

export default DailyFeedbackPopup;
